export interface MovieItem {
  id: string;
  title: string;
  category: 'tv' | 'movie' | 'anime' | 'variety';
  subCategory: string;
  image: string;
  rating: number;
  year: number;
  description: string;
  episodes: string;
  isHot: boolean;
  isNew: boolean;
  director: string;
  actors: string[];
  region: string;
  updateInfo: string;
}

export const movies: MovieItem[] = [
  {
    id: 'tv-1',
    title: '狂飙',
    category: 'tv',
    subCategory: '犯罪',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20crime%20drama%20poster%20style%20image%20with%20dark%20and%20moody%20atmosphere%2C%20police%20officer%20silhouette%20against%20city%20night%20lights%2C%20tense%20and%20gritty%20cinematic%20poster%20design%2C%20deep%20shadows%20and%20high%20contrast%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20professional%20movie%20poster%20aesthetic%20with%20clean%20composition&width=400&height=560&seq=tv-kuangbiao&orientation=portrait',
    rating: 8.5,
    year: 2023,
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年的生死搏斗故事，通过群像叙事展现扫黑行动中的黑白较量与复杂人性。',
    episodes: '共39集',
    isHot: true,
    isNew: false,
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-2',
    title: '繁花',
    category: 'tv',
    subCategory: '都市',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20showing%201990s%20Shanghai%20cityscape%20with%20neon%20lights%20and%20golden%20hues%2C%20nostalgic%20and%20romantic%20atmosphere%2C%20vintage%20Shanghai%20Bund%20skyline%20silhouette%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20classic%20Chinese%20cinema%20poster%20aesthetic%20with%20artistic%20composition&width=400&height=560&seq=tv-fanhua&orientation=portrait',
    rating: 8.7,
    year: 2023,
    description: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀，黄河路上无人不晓。',
    episodes: '共30集',
    isHot: true,
    isNew: true,
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-3',
    title: '庆余年第二季',
    category: 'tv',
    subCategory: '古装',
    image: 'https://readdy.ai/api/search-image?width=400&height=560&seq=tv-qingyunian&orientation=portrait&query=Epic%20Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20palace%20architecture%20and%20martial%20arts%20warrior%20in%20flowing%20robes%2C%20dramatic%20clouds%20and%20mountain%20landscape%20background%2C%20rich%20gold%20and%20crimson%20color%20palette%2C%02traditional%20Chinese%20ink%20painting%20style%20blended%20with%20cinematic%20lighting%2C%20grand%20and%20majestic%20composition',
    rating: 8.3,
    year: 2024,
    description: '范闲经历生死后再度归来，面对更加复杂的朝堂风云和江湖恩怨，他将继续在这波谲云诡的京都城中书写传奇。',
    episodes: '共36集',
    isHot: true,
    isNew: true,
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-4',
    title: '三体',
    category: 'tv',
    subCategory: '科幻',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20drama%20poster%20with%20cosmic%20background%20showing%20three%20suns%20and%20mysterious%20planet%2C%20dark%20space%20atmosphere%20with%20glowing%20particles%2C%20enigmatic%20and%20philosophical%20mood%2C%20deep%20space%20blue%20and%20golden%20light%20contrast%2C%20clean%20minimalist%20sci-fi%20poster%20design%20with%20striking%20visual%20impact&width=400&height=560&seq=tv-santi&orientation=portrait',
    rating: 8.1,
    year: 2023,
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入神秘的ETO组织，在调查中逐渐揭开三体世界的真相。',
    episodes: '共30集',
    isHot: true,
    isNew: false,
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-5',
    title: '甄嬛传',
    category: 'tv',
    subCategory: '古装',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20imperial%20palace%20drama%20poster%20with%20a%20beautiful%20woman%20in%20elaborate%20traditional%20qing%20dynasty%20royal%20costume%2C%20ornate%20golden%20palace%20interior%20background%2C%20rich%20red%20and%20gold%20tapestry%20details%2C%20elegant%20and%20dramatic%20atmosphere%2C%20luxurious%20historical%20Chinese%20aesthetic%20with%20soft%20cinematic%20lighting&width=400&height=560&seq=tv-zhenhuan&orientation=portrait',
    rating: 9.4,
    year: 2011,
    description: '甄嬛从一个不谙世事的少女成长为善于权谋的皇太后的故事，被誉为宫斗剧的巅峰之作，格局宏大细节考究。',
    episodes: '共76集',
    isHot: true,
    isNew: false,
    director: '郑晓龙',
    actors: ['孙俪', '陈建斌', '蔡少芬', '蒋欣'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'tv-6',
    title: '琅琊榜',
    category: 'tv',
    subCategory: '古装',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20political%20drama%20poster%20with%20a%20scholar%20warrior%20in%20white%20traditional%20robes%20standing%20before%20ancient%20Chinese%20palace%20gates%2C%20snowy%20mountain%20landscape%20background%20with%20ink%20wash%20painting%20style%2C%20elegant%20and%20melancholic%20atmosphere%2C%20soft%20silver%20and%20jade%20green%20tones%2C%20refined%20classical%20aesthetic&width=400&height=560&seq=tv-langyabang&orientation=portrait',
    rating: 9.2,
    year: 2015,
    description: '十二年前七万赤焰军被奸人所害全军覆没，冤死梅岭的少帅林殊，十二年后改头换面化身"麒麟才子"梅长苏回到金陵帝都。',
    episodes: '共54集',
    isHot: false,
    isNew: false,
    director: '孔笙',
    actors: ['胡歌', '刘涛', '王凯', '黄维德'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'movie-1',
    title: '流浪地球2',
    category: 'movie',
    subCategory: '科幻',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20blockbuster%20movie%20poster%20showing%20Earth%20with%20massive%20thruster%20engines%20in%20space%2C%20dramatic%20cosmic%20background%20with%20stars%20and%20nebula%2C%20futuristic%20space%20station%20and%20astronauts%2C%20grand%20and%20heroic%20atmosphere%2C%20deep%20blue%20and%20orange%20color%20contrast%2C%20high%20quality%20cinematic%20poster%20design&width=400&height=560&seq=movie-wandering2&orientation=portrait',
    rating: 8.3,
    year: 2023,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，年轻人再次挺身而出。',
    episodes: 'HD',
    isHot: true,
    isNew: false,
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    updateInfo: 'HD高清',
  },
  {
    id: 'movie-2',
    title: '孤注一掷',
    category: 'movie',
    subCategory: '犯罪',
    image: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20gambling%20theme%2C%20mysterious%20shadowy%20figures%20in%20casino%20setting%20with%20neon%20lights%2C%20tense%20and%20dangerous%20atmosphere%2C%20rich%20red%20and%20black%20color%20palette%2C%20gritty%20and%20realistic%20cinematic%20style%2C%20suspenseful%20composition&width=400&height=560&seq=movie-no-more-bets&orientation=portrait',
    rating: 7.3,
    year: 2023,
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友下手套现。',
    episodes: 'HD',
    isHot: true,
    isNew: false,
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君', '王大陆'],
    region: '中国大陆',
    updateInfo: 'HD高清',
  },
  {
    id: 'movie-3',
    title: '封神第一部',
    category: 'movie',
    subCategory: '奇幻',
    image: 'https://readdy.ai/api/search-image?query=Grand%20Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20in%20armor%20riding%20horses%20in%20epic%20battle%20scene%2C%20mythical%20creatures%20and%20golden%20palace%20in%20background%2C%20dramatic%20storm%20clouds%20and%20lighting%2C%20gold%20and%20crimson%20color%20scheme%2C%20majestic%20and%20powerful%20composition%20with%20traditional%20Chinese%20aesthetic&width=400&height=560&seq=movie-fengshen&orientation=portrait',
    rating: 7.8,
    year: 2023,
    description: '商王殷寿暴虐无道，天降大任于姬发，一场浩大的封神之战就此展开。黄渤饰演的姜子牙携封神榜下山，寻找天下共主。',
    episodes: 'HD',
    isHot: false,
    isNew: false,
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    region: '中国大陆',
    updateInfo: 'HD高清',
  },
  {
    id: 'anime-1',
    title: '斗罗大陆',
    category: 'anime',
    subCategory: '热血',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20style%20poster%20with%20a%20young%20martial%20arts%20hero%20in%20blue%20and%20gold%20fantasy%20armor%2C%20magical%20spirit%20rings%20and%20energy%20effects%2C%20ancient%20Chinese%20fantasy%20world%20landscape%2C%20dynamic%20action%20pose%2C%20vibrant%20and%20colorful%20anime%20art%20style%2C%20epic%20fantasy%20atmosphere%20with%20dramatic%20lighting&width=400&height=560&seq=anime-douluo&orientation=portrait',
    rating: 7.5,
    year: 2018,
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆，在这里他将开启全新的人生篇章。',
    episodes: '更新至263集',
    isHot: true,
    isNew: false,
    director: '沈乐平',
    actors: ['沈磊', '程玉珠', '黄翔宇'],
    region: '中国大陆',
    updateInfo: '每周六更新',
  },
  {
    id: 'anime-2',
    title: '凡人修仙传',
    category: 'anime',
    subCategory: '仙侠',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20donghua%20poster%20with%20a%20humble%20young%20cultivator%20in%20simple%20robes%20standing%20on%20a%20misty%20mountain%20peak%2C%20spiritual%20energy%20swirling%20around%2C%20ancient%20Chinese%20landscape%20with%20floating%20islands%2C%20mystical%20and%20philosophical%20atmosphere%2C%20soft%20green%20and%20gold%20tones%2C%20refined%20ink%20painting%20style%20anime%20art&width=400&height=560&seq=anime-fanren&orientation=portrait',
    rating: 8.0,
    year: 2020,
    description: '一个普通的山村穷小子，偶然之下跨入一个江湖小门派，虽然资质平庸，但依靠自身努力和合理算计修炼成仙的故事。',
    episodes: '更新至76集',
    isHot: false,
    isNew: true,
    director: '王昕',
    actors: ['宝木中阳', '郭浩然', '姜广涛'],
    region: '中国大陆',
    updateInfo: '每周日更新',
  },
  {
    id: 'variety-1',
    title: '奔跑吧·生态篇',
    category: 'variety',
    subCategory: '真人秀',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20a%20group%20of%20celebrities%20running%20and%20laughing%20in%20a%20beautiful%20natural%20outdoor%20setting%20with%20green%20mountains%20and%20blue%20sky%2C%20energetic%20and%20fun%20atmosphere%2C%20bright%20and%20vibrant%20colors%2C%20playful%20and%20dynamic%20composition%2C%20modern%20TV%20show%20poster%20design&width=400&height=560&seq=variety-running&orientation=portrait',
    rating: 6.8,
    year: 2024,
    description: '《奔跑吧》全新一季以生态环保为主题，兄弟团走进大自然，在欢乐的游戏竞技中传递绿色生态理念，开启一场别样的奔跑之旅。',
    episodes: '更新至12期',
    isHot: true,
    isNew: true,
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '白鹿'],
    region: '中国大陆',
    updateInfo: '每周五更新',
  },
  {
    id: 'tv-7',
    title: '长相思',
    category: 'tv',
    subCategory: '古装',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20fantasy%20drama%20poster%20with%20beautiful%20woman%20in%20flowing%20ancient%20hanfu%20dress%20in%20a%20blooming%20peach%20blossom%20garden%2C%20dreamy%20and%20ethereal%20atmosphere%20with%20soft%20petal%20falling%2C%20pink%20and%20gold%20warm%20tones%2C%20poetic%20and%20romantic%20classical%20Chinese%20aesthetic%2C%20soft%20focus%20cinematic%20style&width=400&height=560&seq=tv-changxiang&orientation=portrait',
    rating: 7.7,
    year: 2023,
    description: '上古时期，人神妖混居。流落大荒的高辛王姬玖瑶历经百年颠沛之苦，失去了身份和容貌，在清水镇落脚，悬壶济世，恣意不羁。',
    episodes: '共39集',
    isHot: false,
    isNew: false,
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'movie-4',
    title: '满江红',
    category: 'movie',
    subCategory: '悬疑',
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20Chinese%20historical%20mystery%20movie%20poster%20set%20in%20ancient%20Chinese%20courtyard%20with%20crimson%20lanterns%20and%20narrow%20alleyways%2C%20dark%20and%20moody%20night%20atmosphere%2C%20shadowy%20figures%20in%20traditional%20song%20dynasty%20costumes%2C%20deep%20red%20and%20black%20color%20palette%2C%20tense%20and%20mysterious%20composition&width=400&height=560&seq=movie-manjianghong&orientation=portrait',
    rating: 7.4,
    year: 2023,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。',
    episodes: 'HD',
    isHot: false,
    isNew: false,
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    updateInfo: 'HD高清',
  },
  {
    id: 'tv-8',
    title: '与凤行',
    category: 'tv',
    subCategory: '仙侠',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20Chinese%20xianxia%20drama%20poster%20with%20a%20powerful%20female%20immortal%20warrior%20with%20phoenix%20wings%20in%20flowing%20red%20dress%2C%20celestial%20palace%20and%20clouds%20background%2C%20magical%20energy%20effects%20and%20sparks%2C%20epic%20and%20romantic%20atmosphere%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20grand%20fantasy%20cinematic%20poster&width=400&height=560&seq=tv-yufengxing&orientation=portrait',
    rating: 7.2,
    year: 2024,
    description: '灵界碧苍王沈璃为掌握自己的命运逃跑过程中受伤坠落人间，被下凡体验生活的最后一位上古神行止所救，两人从此结下不解之缘。',
    episodes: '共39集',
    isHot: false,
    isNew: true,
    director: '邓科',
    actors: ['赵丽颖', '林更新', '辛云来', '何与'],
    region: '中国大陆',
    updateInfo: '已完结',
  },
  {
    id: 'anime-3',
    title: '完美世界',
    category: 'anime',
    subCategory: '玄幻',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20donghua%20poster%20with%20a%20powerful%20young%20warrior%20with%20glowing%20spiritual%20energy%20standing%20atop%20a%20mountain%20peak%2C%20ancient%20ruins%20and%20floating%20continent%20in%20background%2C%20dynamic%20and%20heroic%20atmosphere%2C%20rich%20gold%20and%20deep%20purple%20contrasting%20colors%2C%20high%20quality%203D%20anime%20art%20style&width=400&height=560&seq=anime-wanmei&orientation=portrait',
    rating: 7.8,
    year: 2021,
    description: '一粒尘可填沧海，一株草斩尽日月星辰。少年石昊从大荒中走出，为了亲友、为了故乡，一步步走向诸天万界的巅峰。',
    episodes: '更新至142集',
    isHot: false,
    isNew: false,
    director: '汪成果',
    actors: ['锦鲤', '刘晴', '赵双'],
    region: '中国大陆',
    updateInfo: '每周四更新',
  },
];

export const categories = [
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line', count: 1568 },
  { slug: 'movie', name: '电影', icon: 'ri-film-line', count: 2341 },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line', count: 892 },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line', count: 645 },
];

export const subCategoriesMap: Record<string, string[]> = {
  tv: ['全部', '古装', '都市', '悬疑', '犯罪', '仙侠', '科幻', '爱情', '历史', '喜剧'],
  movie: ['全部', '动作', '喜剧', '科幻', '悬疑', '爱情', '奇幻', '犯罪', '动画', '战争'],
  anime: ['全部', '热血', '玄幻', '仙侠', '科幻', '搞笑', '恋爱', '治愈', '悬疑', '战斗'],
  variety: ['全部', '真人秀', '音乐', '脱口秀', '美食', '旅行', '竞技', '文化', '喜剧', '访谈'],
};

export const siteInfo = {
  name: '丫丫影院',
  tagline: '免费电视剧全集电影大全，免费高清在线观看全集',
  description: '丫丫影院提供免费电视剧全集和电影大全，无需付费注册，全集免费看，高清不缓冲在线观看，最新免费影视资源。',
  keywords: ['丫丫影院', '免费电视剧全集', '免费电影大全', '全集免费看', '免费高清在线观看', '最新影视', '不缓冲', '免费播放'],
  email: 'contact@yayacinema.com',
  year: 2024,
};

export const aboutInfo = {
  brandStory: '丫丫影院成立于2018年，致力于为广大华语观众提供最新最全的免费影视资源。我们深知用户对于高品质影视内容的需求，因此投入大量资源整合全网优质片源，力求让每一位用户都能享受到流畅、高清的观影体验。经过多年的发展，丫丫影院已经成为国内领先的免费影视平台之一，日活跃用户超过百万。',
  mission: '让每个人都能轻松享受高品质影视内容，打造最值得信赖的免费在线观影平台。',
  values: [
    { title: '用户至上', desc: '始终以用户体验为核心，不断优化产品功能和服务质量。' },
    { title: '内容为王', desc: '持续丰富影视资源库，确保内容新鲜度和多样性。' },
    { title: '技术驱动', desc: '采用先进视频技术，保障高清流畅的播放体验。' },
    { title: '免费初心', desc: '坚持免费模式，让更多人平等享受优质影视内容。' },
  ],
  testimonials: [
    { name: '王先生', role: '资深影迷', content: '丫丫影院真的太方便了，片源丰富更新快，画质清晰不卡顿，已经推荐给身边所有朋友了！', rating: 5 },
    { name: '李女士', role: '追剧达人', content: '找了好久才找到这么全的平台，热门电视剧一应俱全，再也不用到处找资源了，强烈推荐！', rating: 5 },
    { name: '张同学', role: '大学生', content: '作为学生党，免费还能看高清太赞了！动漫资源也很全，满足了我的二次元需求。', rating: 5 },
    { name: '刘女士', role: '全职妈妈', content: '晚上哄完孩子就靠丫丫影院放松了，界面简洁好操作，片源稳定不缓冲，追剧体验一级棒！', rating: 4 },
    { name: '陈先生', role: 'IT从业者', content: '技术层面做得很扎实，高清画质加载速度快，UI设计也很用心，是真正的良心平台。', rating: 5 },
    { name: '赵女士', role: '自由职业者', content: '用了两年多了，看着平台越来越好。更新速度快，新剧几乎同步上线，每天必刷！', rating: 5 },
  ],
  contact: {
    email: 'contact@yayacinema.com',
    wechat: 'yayacinema',
    qq: '88886666',
    workingHours: '周一至周日 9:00 - 22:00',
  },
  faqs: [
    { q: '丫丫影院是否需要注册付费？', a: '完全不需要！丫丫影院始终坚持免费运营，用户无需注册、无需付费即可观看所有内容，我们致力于降低观影门槛。' },
    { q: '为什么观看时会出现缓冲？', a: '如遇缓冲情况，建议检查网络连接或切换播放线路。我们提供多条播放线路供选择，绝大多数情况下1080P高清播放流畅不卡顿。' },
    { q: '网站会及时更新最新剧集吗？', a: '会的，我们拥有专业的更新团队，热门剧集通常会在24小时内同步更新，确保用户不错过任何精彩内容。' },
    { q: '可以在手机上观看吗？', a: '当然可以！丫丫影院已全面适配移动端，您可以在手机、平板等设备上流畅观看，随时随地享受追剧乐趣。' },
    { q: '为什么有些资源无法播放？', a: '若遇无法播放的情况，可尝试切换播放源或稍后再试。如问题持续存在，欢迎通过联系方式反馈给我们。' },
  ],
};